"use client"

import dynamic from "next/dynamic"
import { useRouter, useSearchParams } from "next/navigation"
import { useState } from "react"
import {
  clearStoredRedirect,
  readStoredRedirect,
  safeRedirectPath,
  writeStoredRedirect,
} from "@/src/utils/post-login-redirect"

const Descope = dynamic(() => import("@descope/nextjs-sdk").then((mod) => mod.Descope), { ssr: false })

function isOAuthCallbackPath(path: string): boolean {
  return /[?&]code=/.test(path) && path.includes("descope-login-flow=")
}

function resolveRedirectAtMount(urlParam: string | null | undefined): string {
  if (urlParam && !isOAuthCallbackPath(urlParam)) {
    const safe = safeRedirectPath(urlParam)
    if (safe) {
      writeStoredRedirect(safe)
      console.log("[deeplink] sign-in: stored from URL param, returning", safe)
      return safe
    }
  }
  if (urlParam && isOAuthCallbackPath(urlParam)) {
    console.log("[deeplink] sign-in: urlParam looks like OAuth callback, preserving existing storage")
  }
  const fallback = safeRedirectPath(readStoredRedirect()) ?? "/"
  console.log("[deeplink] sign-in: using fallback / existing storage,", fallback)
  return fallback
}

const SignInPage = () => {
  const router = useRouter()
  const searchParams = useSearchParams()
  const rawRedirect = searchParams?.get("redirect")

  const [redirectTo] = useState(() => resolveRedirectAtMount(rawRedirect))

  const handleSuccess = () => {
    console.log("[deeplink] sign-in handleSuccess fired, pushing", redirectTo)
    clearStoredRedirect()
    router.push(redirectTo)
  }

  return (
    <div className="w-screen h-screen descope-container flex items-center justify-center bg-light-gray-background">
      <Descope
        flowId="sign-up-or-in"
        onSuccess={handleSuccess}
        onError={(e: any) => console.error("Login error:", e.detail)}
      />
    </div>
  )
}

export default SignInPage
